import React from "react";

const IconPhone = ({
  width = "20",
  height = "20",
  fill = "#0179FF",
  className = "",
}) => {
  return (
    <svg
      viewBox="0 0 16 16"
      width={width}
      height={height}
      className={className ? className : null}
      data-name="iconPhone"
    >
      <path
        fill={fill}
        d="M4.25 0.5H1.33333C0.875 0.5 0.5 0.875 0.5 1.33333C0.5 9.15833 6.84167 15.5 14.6667 15.5C15.125 15.5 15.5 15.125 15.5 14.6667V11.7583C15.5 11.3 15.125 10.925 14.6667 10.925C13.6333 10.925 12.625 10.7583 11.6917 10.45C11.6083 10.4167 11.5167 10.4083 11.4333 10.4083C11.2167 10.4083 11.0083 10.4917 10.8417 10.65L9.00833 12.4833C6.65 11.275 4.71667 9.35 3.51667 6.99167L5.35 5.15833C5.58333 4.925 5.65 4.6 5.55833 4.30833C5.25 3.375 5.08333 2.375 5.08333 1.33333C5.08333 0.875 4.70833 0.5 4.25 0.5Z"
      />
    </svg>
  );
};

export default IconPhone;
